import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  Typography,
  useTheme,
} from '@mui/material';

import { sxStyled } from './styles';

const FillterBaggage = ({ flightFilters }) => {
  const theme = useTheme();

  const sxStyle = sxStyled(theme);

  const { baggage, baggageSelected, baggageHandleChange } = flightFilters;

  return (
    <Grid item lg={12} sm={12} xs={12} sx={sxStyle.filterBox}>
      <Typography
        style={{
          fontSize: '15px',
          color: 'black',
          fontWeight: '600',
        }}
      >
        Equipaje
      </Typography>
      <Box style={{ display: 'flex', flexDirection: 'column' }}>
        {baggage.map((baggage, i) => (
          <FormControlLabel
            key={`${baggage.name}-${i}`}
            sx={{
              ...sxStyle.formControlLabelRoot,
              '& .MuiFormControlLabel-label': {
                ...sxStyle.formControlLabel,
              },
              fontFamily: 'Open Sans',
            }}
            onClick={baggageHandleChange}
            value={baggage.value}
            control={
              <Checkbox
                checked={baggageSelected === baggage.value}
                name={baggage.name}
                sx={{
                  fontFamily: 'Open Sans',
                  color: theme.tertiary,
                  '&.Mui-checked': { color: theme.tertiary },
                }}
              />
            }
            label={baggage.name}
          />
        ))}
      </Box>

      <Divider sx={sxStyle.filterBoxDivider} />
    </Grid>
  );
};
export default FillterBaggage;
